"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOverflowDetector = void 0;
var DetectableOverflow_1 = require("./DetectableOverflow");
var useOverflowDetector_1 = require("./useOverflowDetector");
Object.defineProperty(exports, "useOverflowDetector", { enumerable: true, get: function () { return useOverflowDetector_1.useOverflowDetector; } });
exports.default = DetectableOverflow_1.DetectableOverflow;
//# sourceMappingURL=index.js.map